import React from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  FaHome,
  FaFolder,
  FaFileAlt,
  FaSignOutAlt,
  FaUser,
} from "react-icons/fa";
import logo from "../../../assets/irc-logo-rb.png";

const sidebarLinks = [
  { to: "/home", icon: <FaHome style={{ marginRight: "8px" }} />, label: "Accueil", onClick: "toggleSidebar" },
  { to: "/chercheur-projet", icon: <FaFolder style={{ marginRight: "8px" }} />, label: "Compétitions" },
  { to: "/MyProject", icon: <FaFolder style={{ marginRight: "8px" }} />, label: "Mon projet" },
  { to: "/documents", icon: <FaFileAlt style={{ marginRight: "8px" }} />, label: "Documents" },
  { to: "/Mon-compte", icon: <FaUser style={{ marginRight: "8px" }} />, label: "Mon compte" },
];

const Sidebar = ({ onToggleSidebar }) => {
  const navigate = useNavigate();
  return (
    <div className="sidebar">
      <div className="logo-container">
        <img src={logo} alt="IRC Logo" className="logo" />
      </div>
      {sidebarLinks.map((item) => (
        <Link
          key={item.to}
          to={item.to}
          className="sidebar-item"
          style={{ textDecoration: "none" }}
          onClick={item.onClick === "toggleSidebar" ? onToggleSidebar : undefined}
        >
          {item.icon}
          {item.label}
        </Link>
      ))}
      <div
        className="sidebar-item"
        style={{ cursor: "pointer" }}
        onClick={() => navigate("/login")}
      >
        <FaSignOutAlt style={{ marginRight: "8px" }} />
        Se déconnecter
      </div>
    </div>
  );
};

export default Sidebar;
